import styled from "styled-components";
import Button from "../../ui/Button";
import { useGetAllCarInfoTypeQuery } from "../../utils/carInfoType.utils";
import { EllipsisVerticalIcon } from "../../utils/icon.utils";
import { arrayMap } from "../../utils/array.utils";

export default function CarInfoFilter({ activeId = "", handleClick = () => {} }) {
  const { loading, data } = useGetAllCarInfoTypeQuery({
    query: ``,
    key: "CarInfoTypeForCarInfoFilter"
  });

  const carInfoTypes = data?.length ? data : [];

  return (
    <>
      <Button color="primary" icon={EllipsisVerticalIcon} data-bs-toggle="dropdown" />

      <ul className="dropdown-menu shadow border-0 mt-3 p-0">
        {loading && <DropdownItem>Loading...</DropdownItem>}
        <DropdownItem onClick={() => handleClick("")}>All</DropdownItem>
        {arrayMap(carInfoTypes, (item) => (
          <DropdownItem
            onClick={() => handleClick(item?.id)}
            className={activeId === item?.id ? "active" : ""}
            key={item?.id}>
            {item?.name ?? ""}
          </DropdownItem>
        ))}
      </ul>
    </>
  );
}

const DropdownItem = styled.li`
  cursor: pointer;
  font-weight: 600;
  color: rgb(var(--default));
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  &:hover {
    background-color: rgb(var(--primary));
    color: white;
  }
  &.active {
    background-color: rgb(var(--primary));
    color: white;
  }
`;
